var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar",style:({
    'max-width': _vm.screenWidth + 'px',
  })},_vm._l((_vm.videos),function(video,index){return _c('div',{key:index},[_c('div',{class:{
        'section-normal': video._id !== _vm.currentVideo,
        'section-selected': video._id === _vm.currentVideo,
      },on:{"click":function($event){return _vm.onVideo(video)}}},[_c('label',{staticClass:"chapter-title"},[_vm._v(_vm._s(video.title))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }